export default __webpack_public_path__ + "static/media/certificate-badge-code.32c14973.svg";